<!-- Usage   -->
<!--
<sa-input-html #Group [(text)]="Idea.Group" [title]="'Group'" [required]="'text'"></sa-input-html>
-->
<div class="form-group">
  <label *ngIf="title != ''" class="sa-form-label">
    {{title}}
    <span *ngIf="required != 'none'" style="color:red"> *</span>
  </label>
  <input id="{{id}}" type="text" class="form-control sa-formfield-input" [ngModel]="text" (ngModelChange)="change($event)" [ngClass]="text || (required != 'required') ? 'hasValue' : 'noValue'">
  <!--<label class="sa-formfield-label">{{title}} <span *ngIf="required != 'none'" style="color:red"> *</span></label>-->
</div>
